import { treasuryAmount } from '@liquid-spirit/api/treasury-figures';
export function normalizeFundsPayload(payload) {
  const funds = [];

  if (!Array.isArray(payload)) {
    throw new Error('Invalid treasury funds response.');
  }

  payload.forEach((item) => {
    const fundName = item?.fundName || item?.name || '';
    const fundId = item?.id || item?._id;
    const balanceRaw = treasuryAmount(item?.balance ?? item?.amount);
    const currency = String(item?.currency || '').trim().toUpperCase();

    if (!fundName) {
      return;
    }

    funds.push({
      id: String(fundId || fundName),
      fundName,
      balance: balanceRaw,
      currency,
      assetType: item?.assetType || 'fiat',
      displaySymbol: item?.displaySymbol || null,
      description: item?.description || '',
      lastUpdated: item?.lastUpdated ?? item?.balanceUpdatedAt ?? null,
      observedOnchainBalance: typeof item?.observedOnchainBalance === 'number' ? item.observedOnchainBalance : null,
      observedOnchainBalanceUpdatedAt: item?.observedOnchainBalanceUpdatedAt || null,
      chain: item?.chain || null,
      tokenSymbol: item?.tokenSymbol || null,
      walletCount: typeof item?.walletCount === 'number' ? item.walletCount : 0,
      isOnchainTracked: Boolean(item?.isOnchainTracked),
      reconciliationReviewStatus: item?.reconciliationReviewStatus || 'unreviewed',
      reconciliationReviewedAt: item?.reconciliationReviewedAt || null,
      reconciliationReviewNote: item?.reconciliationReviewNote || null,
      reconciliationReviewedBy: item?.reconciliationReviewedBy || null,
      donationConfig: {
        isAcceptingContributions: Boolean(item?.donationConfig?.isAcceptingContributions),
        visibility: item?.donationConfig?.visibility || 'internal',
        suggestedAmounts: Array.isArray(item?.donationConfig?.suggestedAmounts) ? item.donationConfig.suggestedAmounts : [],
        suggestedCurrency: item?.donationConfig?.suggestedCurrency || currency,
        instructions: item?.donationConfig?.instructions || '',
        contactEmail: item?.donationConfig?.contactEmail || null,
        externalUrl: item?.donationConfig?.externalUrl || null,
        referenceLabel: item?.donationConfig?.referenceLabel || null,
        referenceHint: item?.donationConfig?.referenceHint || null,
      },
    });
  });

  return funds;
}

export function normalizeTreasuryWalletRows(payload) {
  const rows = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : [];

  return rows.map((wallet) => ({
    ...wallet,
    donationConfig: {
      isDefaultDestination: Boolean(wallet?.donationConfig?.isDefaultDestination),
      isAcceptingContributions: Boolean(wallet?.donationConfig?.isAcceptingContributions),
      visibility: wallet?.donationConfig?.visibility || 'internal',
      destinationLabel: wallet?.donationConfig?.destinationLabel || null,
      instructions: wallet?.donationConfig?.instructions || '',
      qrCodeUrl: wallet?.donationConfig?.qrCodeUrl || null,
      referenceHint: wallet?.donationConfig?.referenceHint || null,
    },
  }));
}

export function normalizePaymentIntent(item) {
  if (!item) return null;

  return {
    id: item.id || item._id,
    fundId: item.fundId || null,
    fundName: item.fundName || null,
    fundCode: item.fundCode || null,
    memberId: item.memberId || null,
    destinationWalletId: item.destinationWalletId || null,
    destinationWalletLabel: item.destinationWalletLabel || null,
    destinationAddressSnapshot: item.destinationAddressSnapshot || null,
    destinationExplorerUrl: item.destinationExplorerUrl || null,
    chain: item.chain || null,
    tokenSymbol: item.tokenSymbol || null,
    displaySymbol: item.displaySymbol || item.tokenSymbol || null,
    expectedAmount: typeof item.expectedAmount === 'number' ? item.expectedAmount : null,
    expectedCurrency: item.expectedCurrency || null,
    suggestedAmount: typeof item.suggestedAmount === 'number' ? item.suggestedAmount : null,
    reference: item.reference || null,
    memberNote: item.memberNote || '',
    status: item.status || 'draft',
    paymentWindowMinutes: typeof item.paymentWindowMinutes === 'number' ? item.paymentWindowMinutes : 30,
    expiresAt: item.expiresAt || null,
    walletAddress: item.walletAddress || null,
    txHash: item.txHash || null,
    submittedAt: item.submittedAt || null,
    observedAmount: typeof item.observedAmount === 'number' ? item.observedAmount : null,
    observedAt: item.observedAt || null,
    verifiedAt: item.verifiedAt || null,
    failureReason: item.failureReason || null,
    mismatchReason: item.mismatchReason || null,
    operatorReviewStatus: item.operatorReviewStatus || 'unreviewed',
    operatorReviewNote: item.operatorReviewNote || null,
    operatorReviewedAt: item.operatorReviewedAt || null,
    operatorReviewedBy: item.operatorReviewedBy || null,
    metadata: item.metadata || {},
    createdAt: item.createdAt || null,
    updatedAt: item.updatedAt || null,
  };
}
